import React from 'react';
import { observable } from "mobx";
import BookingService from "../../../../services/BookingService";
import moment from "moment";
import { formatarDataCustomHTML, formatarCheck, exibirItensArray, situacaoFormatter, 
         situacaoBookingFormater, appendFieldObjSpan, formatarData, formataZero,
         formatNullableValue, formatarPopOver, navioDataPopOver  } from '../../../../utils/formatar';
import { buscaFiltrarVazio, buscaSemResultado } from '../../../../utils/mensagens';
import { sortCaret } from '../../../comum/components/Icones';

export default class BookingStore {

    @observable bookingLista;
    @observable qtdRegistros;
    @observable loading;

    /** Paginação */
    @observable total;
    @observable hasNextPage;

    @observable itens;
    @observable hasMore;

    /** Filtro */
    @observable filtroSelecionado;

    @observable colunas;
    @observable capacidade;
    @observable containersAgendados;
    @observable operacoes;
    @observable operacaoSelecionada;
    @observable codigoBooking;

    @observable tableMessage;
    @observable navioData;

    constructor() {
        this.bookingLista = [];
        this.qtdRegistros = null;
        this.loading = false;
        this.filtrado = false;
        
        this.operacoes = [];
        this.itens = [];
        this.hasMore = false;
        this.toShow = 20;
        this.turn = 0;

        this.tableMessage = buscaFiltrarVazio
        
        /** Paginação */
        this.total = null;
        this.hasNextPage = null;

        /** Filtros */
        this.filtroSelecionado = [];
        this.operacaoSelecionada = false;
        this.codigoBooking = false;
        this.tamanhoPagina = 400;
        
        this.navioData = {};

        this.todasColunas = [{
            dataField: 'booking.Nbr',
            text: 'Booking',
            headerStyle: () => {
                return { maxWidth: "80px" };
            },
            sort: true,
            sortCaret: sortCaret,
        }, {
            dataField: 'booking.VesselName',
            text: 'Navio / Viagem',
            searchable: false,           
            formatter: navioDataPopOver, 
            formatExtraData: 'booking-VesselVisit', //eu preciso passar um - no lugar do ponto pois, booking.VesselVisit só me manda booking. Posso averiguar mais tarde.
            events: {onClick: this.clickPopOverNavio},
            sort: true,
            sortCaret: sortCaret,
        }, {
            dataField: 'booking.LineOperator',
            text: 'Armador',
            searchable: false,
            headerStyle: () => {
                return { maxWidth: "80px" };
            },
            sort: true,
            sortCaret: sortCaret,
        },{
            dataField: 'booking.VesselDeadLine',
            text: 'Deadline Op.',
            searchable: false,
            formatter: formatarDataCustomHTML,
            sort: true,
            sortCaret: sortCaret,
        },{
            dataField: 'booking.Pod',
            text: 'Porto Desc.',
            searchable: false,
            headerStyle: () => {
                return { maxWidth: "140px" };
            },
            sort: true,
            sortCaret: sortCaret,
        },{
            dataField: 'booking.Destination',
            text: 'Destino',
            searchable: false,
            sort: true,
            sortCaret: sortCaret,
        },{
            dataField: 'itens',
            text: 'Tam / Tipo',
            sortCaret: sortCaret,
            searchable: false,
            formatter: exibirItensArray,
            formatExtraData: 'Tipo'
        },{
            dataField: 'booking.QtdAgendBkn',
            text: 'Qtd. Agendados',
            searchable: false,
            sort: true,
            sortCaret: sortCaret,
        },{
            dataField: 'itens',
            text: 'Qtd. Prev.',
            formatter: exibirItensArray,
            formatExtraData: 'Qtd',
            searchable: false,
            sortCaret: sortCaret,
        }, {
            dataField: 'itens',
            text: 'Pátio',
            searchable: false,
            formatter: exibirItensArray,
            formatExtraData: 'Patio',
            sortCaret: sortCaret,
        }, {
            dataField: 'itens',
            text: 'Saída',
            searchable: false,
            formatter: exibirItensArray,
            formatExtraData: 'Saida',
            sortCaret: sortCaret,
        }, {
            dataField: 'booking.Status',
            text: 'Situação Navio',
            searchable: false,
            sort: true,
            sortCaret: sortCaret,
            formatter: situacaoFormatter
        }];

        this.colunas = this.todasColunas;

        this.capacidade = [ { titulo : "Tipo", field: ["Tipo"], tamanhoCol:1, hidden: false},
            { titulo : "Qtd", field: ["Qtd"], tamanhoCol:1, hidden: false},
            { titulo : "UN", field: ["Un"], tamanhoCol:1, hidden: false},
            { titulo : "Temp.", field: ["Temperature"], tamanhoCol:2, hidden: false, formatacao: formataZero},
            { titulo : "Imo", field: ["Imo"], tamanhoCol:1, hidden: false},
            { titulo : "Reefer", field: ["IsReefer"], tamanhoCol:2, hidden: false, formatacao: formatarCheck},
            { titulo : "Perigosa", field: ["IsHazardous"], tamanhoCol:2, hidden: false, formatacao: formatarCheck},
            { titulo : "OverDimension", field: ["IsOog"], tamanhoCol:3, hidden: false, formatacao: formatarCheck}];

        this.containerAgendados = [ { titulo : "Containers", field: ["Container"], tamanhoCol:3, hidden: false},
            { titulo : "Tipo", field: ["Tipo"], tamanhoCol:1, hidden: false},
            { titulo : "Armador", field: ["LineOperator"], tamanhoCol:2, hidden: false},
            { titulo : "Entrada", field: ["TimeIn"], tamanhoCol:2, hidden: false, formatacao: formatarDataCustomHTML},
            { titulo : "Data Saída", field: ["DatEntrega"], tamanhoCol:3, hidden: false, formatacao: formatarDataCustomHTML},
            { titulo : "Iso", field: ["Iso"], tamanhoCol:1, hidden: false},
            { titulo : "Status", field: ["Situacao"], tamanhoCol:3, hidden: false, formatacao: situacaoBookingFormater}];

        /** Serviços de Bookings */
        this.bookingService = new BookingService();
    }

    clickPopOverNavio = (e, column, columnIndex, row, rowIndex) => {
        const clicked = document.getElementById(`navio_${row.Navio ? row.Navio.NavioId: ""}`);
        this.popX = clicked.getBoundingClientRect().x;
        this.popY = clicked.getBoundingClientRect().y + window.scrollY;
        this.navioData = {
            popOverId : `navio_${row.Navio ? row.Navio.NavioId: ""}`, 
            Servico: formatNullableValue(row.Navio && row.Navio.ServicoNome ? row.Navio.ServicoNome :"" ),
            PrevisaoChegada: formatNullableValue(row.Navio && row.Navio.EtaFormat ? row.Navio.EtaFormat :""),
            PrevisaoSaida: formatNullableValue(row.Navio && row.Navio.EtdFormat ? row.Navio.EtdFormat : ""),
            AtracacaoReal: formatNullableValue(row.Navio && row.Navio.ChegadaRealFormat ? row.Navio.ChegadaRealFormat : ""),
            InicioReal: formatNullableValue(row.Navio && row.Navio.InicioRealFormat ? row.Navio.InicioRealFormat :""),
            FimReal: formatNullableValue(row.Navio && row.Navio.FimRealFormat ? row.Navio.FimRealFormat :""),
            Desatracacao: formatNullableValue(row.Navio && row.Navio.PartidaRealFormat ? row.Navio.PartidaRealFormat : ""),
            Inicio: formatNullableValue(row.Navio && row.Navio.InicioRecebCheioFormat ? row.Navio.InicioRecebCheioFormat : ""),
            DeadLine: formatNullableValue(row.Navio && row.Navio.DeadlineDryFormat ? row.Navio.DeadlineDryFormat : ""),
        }
    }

    carregarLista() {
        this.filtrado = true;
        this.loading = true;
        this.seletorPeriodo = false;
        this.bookingLista = [];
        this.filtroSelecionado["TamanhoPagina"] = this.tamanhoPagina;


        if(!this.codigoBooking && !this.operacaoSelecionada){
            this.loading = false;
            this.bookingLista = [];
            this.tableMessage = buscaSemResultado
            this.total = 0
            this.filtrado = false;

        }else{
            const loadingPromises = Promise.all([
                this.bookingService.listarComDetalhes(this.filtroSelecionado).then(response => {
                    this.bookingLista = response.data.Data;
                    this.loadFirstTurn()
                    this.total = response.data.Total;
                    //this.hasNextPage = response.data.HasNextPage;
                }).catch(error => {
                    console.log(error);
                }),
            ]);
            this.tableMessage = buscaSemResultado
            loadingPromises.then(() => { this.loading = false; }
            ).catch((error) => { 
                console.error(error)
                this.loading = false
            });
        }

    }

    loadFirstTurn = () => {
        this.itens = this.bookingLista.slice(0, this.toShow);
        this.turn = 1;
        this.hasMore = this.itens.length < this.bookingLista.length;
    };

    loadNextTurn = () => {
        this.itens = [];
        this.itens = this.bookingLista.slice(0, (this.turn+1)*this.toShow);
        this.turn = this.turn + 1;

        this.hasMore = this.itens.length < this.bookingLista.length;
    };

    carregarOperacoes(){

        this.operacoes = [];

        const loadingPromises = Promise.all([
            this.bookingService.listarOperacoes().then(response => {
                this.operacoes = response.data;

            }).catch(error => {
                console.log(error);
            }),
        ]);
        loadingPromises.then(() => { }).catch((error) => { console.error(error) });
    }


    selecionarOperacao(valor) {
        this.operacaoSelecionada = (valor!==null) ? valor.value : "";
        this.filtroSelecionado["vesselVisit"] = this.operacaoSelecionada;
        if( valor==="" ){
            delete this.filtroSelecionado["vesselVisit"];
        }
    };


    carregarPorCodigo(valor){
        let minValor
        if(typeof(valor) === 'string'){
            minValor = valor.toUpperCase()
            minValor = minValor.replace(/[ ]/g,'')
        }else{
            minValor = valor
        }
        
        this.codigoBooking = minValor;
        this.filtroSelecionado["Nbr"] = this.codigoBooking;

        if(valor && valor.length > 3) {

        } else if( valor==="" ) {

            delete this.filtroSelecionado["Nbr"];
        }
    }

}


// WEBPACK FOOTER //
// ./src/modules/consultas/booking/stores/BookingStore.js